

const activities = [
  
  {
    path: '/activity/landingpage',
    name: '缺钱不求人',
    // component: LandingPage,
    component: () => import(/* webpackChunkName: "landingpage" */ '@/pages/Activity/LandPage/index.vue'),
    meta: {
      title: '缺钱不求人',
    },
  },
  {
    path: '/download',
    component: () => import(/* webpackChunkName: "download" */'@/pages/Activity/downIndex.vue'),
    meta: {
      title: '信用飞',
    },
  },
  {
    path: '/activity/load',
    name: '',
    // component: LuckyBox,
    component: () => import(/* webpackChunkName: "load" */ '@/pages/Activity/load.vue'),
    meta: {
      title: '最高20万额度',
    },
  },
  {
    path: '/activity/loadAl',
    name: '',
    // component: LuckyBox,
    component: () => import(/* webpackChunkName: "loadAl" */ '@/pages/Activity/loadAl.vue'),
    meta: {
      title: '最高20万额度',
    },
  },
  {
    path: '/activity/loadFour',
    name: '',
    // component: LuckyBox,
    component: () => import(/* webpackChunkName: "loadFour" */  '@/pages/Activity/loadFour.vue'),
    meta: {
      title: '信用飞-最高20万额度',
    },
  },
  {
    path: '/activity/loadNew',
    name: '',
    // component: LuckyBox,
    component: () => import( /* webpackChunkName: "loadNew" */ '@/pages/Activity/loadNew.vue'),
    meta: {
      title: '最高20万额度',
    },
  },
  {
    path: '/activity/guide',
    name: '',
    component: () => import(  /* webpackChunkName: "guide" */ '@/pages/Activity/guide.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/activity/lost',
    name: '',
    component: () => import( /* webpackChunkName: "lost" */ '@/pages/Activity/lost.vue'),
    meta: {
      title: '',
    },
  }
];

export default activities;